import { ReactNode } from 'react';
import { useLocation } from 'react-router-dom';
import { Navigation } from '@/components/layout/Navigation';
import { SiteFooter } from '@/components/layout/SiteFooter';

interface AppLayoutProps {
  children: ReactNode;
}

// Routes where navigation and footer should be hidden
const ADMIN_ROUTE_SEGMENTS = ['/admin', '/enterprise'];

export function AppLayout({ children }: AppLayoutProps) {
  const location = useLocation();
  
  const isAdminPage = ADMIN_ROUTE_SEGMENTS.some(segment => 
    location.pathname.startsWith(segment)
  );

  // Pages with full-width layout (no restrictive wrapper)
  const isFullWidthPage = ['/', '/about', '/conseil', '/contact', '/cas-clients'].includes(location.pathname);

  return (
    <div className="min-h-screen bg-background">
      {!isAdminPage && <Navigation />}
      {isAdminPage ? children : (
        <>
          {isFullWidthPage ? (
            <div className="pt-24">
              {children}
            </div>
          ) : (
            <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 pt-24">
              {children}
            </main>
          )}
          <SiteFooter />
        </>
      )}
    </div>
  );
}
